import React from 'react';
import classNames from 'classnames';

export default function PlaceholderCard({
  isDraggingOver,
  placeHolderText,
  style,
}) {
  return (
    <div
      id="vacant"
      className={classNames({
        'new-vacant-ecap-drag-drop': true,
        'new-vacant-ecap-drag-drop-dragging-over': isDraggingOver,
      })}
      style={style}
    >
      <p
        className="drag-here truncated-class-text-classlist"
        style={{ visibility: isDraggingOver ? 'hidden' : null }}
      >
        {placeHolderText}
      </p>
    </div>
  );
}
